import { motion } from 'framer-motion'

import img1 from '../../assets/img1.jpg'
import img2 from '../../assets/img2.jpg'
import img3 from '../../assets/img3.jpg'
import img4 from '../../assets/img4.jpg'

import { PortfolioSlider } from '../../components'
import Loader from '../../components/Loader/Loader'
import { useAllprojectsQuery } from '../../helpers/projectsApi'


const PortfolioSection = ({ darkToggle }) => {

    let page = 1
    let isHome = true

    const { data, isFetching } = useAllprojectsQuery({ page, isHome })

    return (
        <div className="max-w-screen-2xl mx-auto px-4 md:px-5 py-6 md:py-10 ">

            {isFetching ? <Loader text='Loading projects...' height={'50vh'} /> : (
                <div>
                    {data.projects.length > 0 && (
                        <div>
                            <motion.div
                                whileInView={{ opacity: [0, 1] }}
                                transition={{ duration: 1.0 }}>
                                <p className="text-2xl font-bold text-center dark:text-white">
                                    Work{" "}
                                    <span className="text-red-500">
                                        Portfolio
                                    </span>
                                </p>
                            </motion.div>

                            <PortfolioSlider data={data.projects} darkToggle={darkToggle} />

                        </div>
                    )}
                </div>
            )}


        </div>
    )
}

export default PortfolioSection